<template>
  <Popover class="absolute inset-0">
    <PopoverButton class="absolute inset-0 flex justify-center items-center" @click="show">
      <EllipsisHorizontalIcon class="h-4 w-4 mr-1" />
    </PopoverButton>

    <transition-appear origin="center">
      <PopoverPanel v-if="isOpened" class="absolute top-[5px] right-[5px] w-screen max-w-max" static>
        <OnClickOutside @trigger="close">
          <div class="isolate inline-flex rounded-md shadow-lg">
            <template v-if="isAdmin()">
              <button
                type="button"
                class="btn-list-action rounded-l-md"
                @click="emit('delete', row)"
              >
                <TrashIcon class="mr-2 h-3 text-slate-400" />
                Delete
              </button>

              <button
                v-if="row.deletedAt"
                type="button"
                class="btn-list-action"
                @click="emit('showProgram', row)"
              >
                <EyeIcon class="mr-2 h-3 text-slate-400" />
                Show
              </button>

              <button
                v-else
                type="button"
                class="btn-list-action"
                @click="emit('hideProgram', row)"
              >
                <EyeSlashIcon class="mr-2 h-3 text-slate-400" />
                Hide
              </button>

              <button
                v-if="row.isEnabled"
                type="button"
                class="btn-list-action"
                @click="emit('disable', row)"
              >
                <LockClosedIcon class="mr-2 h-3 text-slate-400" />
                Disable
              </button>

              <button
                v-else
                type="button"
                class="btn-list-action"
                @click="emit('enable', row)"
              >
                <LockOpenIcon class="mr-2 h-3 text-slate-400" />
                Enable
              </button>
            </template>

            <router-link
              :to="`/program/seo/${row.id}`"
              class="btn-list-action"
            >
              <SparklesIcon class="mr-2 h-3 text-slate-400" />
              SEO
            </router-link>

            <router-link
              v-if="isAdmin()"
              :to="`/program/${row.id}`"
              class="btn-list-action rounded-r-md"
            >
              <PencilSquareIcon class="mr-2 h-3 text-slate-400" />
              Edit
            </router-link>
          </div>
        </OnClickOutside>
      </PopoverPanel>
    </transition-appear>
  </Popover>
</template>

<script setup>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import TransitionAppear from './TransitionAppear.vue';
import { ref, watch } from 'vue';
import { OnClickOutside } from '@vueuse/components';
import {
  EllipsisHorizontalIcon,
  TrashIcon,
  PencilSquareIcon,
  EyeIcon,
  EyeSlashIcon,
  LockOpenIcon,
  LockClosedIcon,
  SparklesIcon
} from '@heroicons/vue/24/outline';
import { isAdmin } from '../composables/useAuth';

const props = defineProps({
  row: {
    type: Object,
    default: () => {}
  },
  index: {
    type: Number,
    default: null
  },
  isRowHovered: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([ 'delete', 'showProgram', 'hideProgram', 'enable', 'disable' ]);

const isOpened = ref(false);

watch(() => props.isRowHovered, val => isOpened.value = val);

function show() {
  isOpened.value = true;
}

function close() {
  isOpened.value = false;
}
</script>
